import { useState, useEffect, useMemo } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { documentHeaderLabel } from "../common/fields";

function DownloadZipDoc(props) {
  const { data, show, onHide, documentsList, downloadDocumentsAsZip } = props;

  const [checkedItems, setCheckedItems] = useState({});
  const [selectedDocs, setSelectedDocs] = useState([]);

  const approvedDocs = useMemo(
    () => documentsList.filter((doc) => doc.isApproved),
    [documentsList]
  );

  const enrichedData = data
    .map((item) => {
      // Always include "Select All"
      if (item.dataKey === "all") {
        return item;
      }

      const matchingDoc = approvedDocs.find(
        (doc) => doc.documentName === item.dataKey
      );

      // Only include if approved
      if (matchingDoc && matchingDoc.isApproved) {
        return {
          ...item,
          documentPath: matchingDoc.documentPath,
        };
      }

      return null; // Exclude if not approved
    })
    .filter((item) => item !== null);

  const originallimitSettingDocumentsHeaderv = [...enrichedData];

  const [docHeader, setDocHeader] = useState([
    ...originallimitSettingDocumentsHeaderv,
  ]);

  const approvedDocsMap = useMemo(() => {
    const map = {};
    approvedDocs.forEach((doc) => {
      map[doc.documentName] = doc;
    });
    return map;
  }, [approvedDocs]);

  useEffect(() => {
    const initialChecks = { all: false };
    data.forEach((doc) => {
      if (doc.dataKey !== "all") {
        initialChecks[doc.dataKey] = false;
      }
    });
    setCheckedItems(initialChecks);
  }, [data]);

  const allChecked = data
    .filter((doc) => doc.dataKey !== "all")
    .every((doc) => checkedItems[doc.dataKey] || !approvedDocsMap[doc.dataKey]);

  const handleChange = (e) => {
    const { name, checked } = e.target;

    if (name === "all") {
      const newChecked = { all: checked };
      data.forEach((doc) => {
        if (doc.dataKey !== "all") {
          //   newChecked[doc.dataKey] = !!approvedDocsMap[doc.dataKey] && checked;
          newChecked[doc.dataKey] = !!approvedDocsMap[doc.dataKey] && checked;
        }
      });
      setCheckedItems(newChecked);
    } else {
      setCheckedItems((prev) => {
        const updated = { ...prev, [name]: checked };

        // Check if all individual checkboxes are checked
        const allChecked = data
          .filter((doc) => doc.dataKey !== "all")
          .every((doc) =>
            !!approvedDocsMap[doc.dataKey] ? updated[doc.dataKey] : true
          );

        updated.all = allChecked;
        return updated;
      });
    }
  };

  useEffect(() => {
    const selected = [];

    // Object.entries(checkedItems).forEach(([key, isChecked]) => {
    //   if (isChecked && approvedDocsMap[key]) {
    //     const doc = approvedDocsMap[key];
    //     selected.push({
    //       documentName: doc.documentName,
    //       documentPath: doc.documentPath,
    //     });
    //   }
    // });

    Object.entries(checkedItems).forEach(([key, isChecked]) => {
      if (isChecked && approvedDocsMap[key]) {
        const doc = approvedDocsMap[key];

        // Find the matching header from the data array
        const matchedHeader =
          data.find((item) => item.dataKey === key)?.header || "Unknown Header";

        selected.push({
          header: matchedHeader,
          documentName: doc.documentName,
          documentPath: doc.documentPath,
        });
      }
    });


    setSelectedDocs(selected);
  }, [checkedItems, approvedDocsMap]);

  const handleSearchLimitSetting = (e) => {
    const { name, value } = e?.target;
    const searchData = originallimitSettingDocumentsHeaderv?.filter((val) => {
      const match = val?.header?.toLowerCase().includes(value?.toLowerCase());

      return match;
    });

    setDocHeader(searchData);
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" style={{ top: 0 }}>
      <Modal.Header closeButton>
        <Modal.Title>Select Documents</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div
          className="col-12 mb-3"
          style={{ position: "sticky", top: 0, zIndex: 5, background: "#fff" }}
        >
          <input
            className="form-control"
            name="search"
            placeholder="Search by document name"
            onChange={handleSearchLimitSetting}
          />
        </div>
        <div
          className="card p-3 shadow-sm border"
          style={{ maxHeight: "400px", overflowY: "auto" }}
        >
          <div className="row">
            {docHeader.map((doc) => (
              <div className="col-12 col-sm-6 col-lg-4 mb-3" key={doc?.dataKey}>
                <div className="form-check d-flex align-items-center">
                  <input
                    className="form-check-input me-2"
                    type="checkbox"
                    id={doc?.dataKey}
                    value={doc?.dataKey}
                    name={doc?.dataKey}
                    checked={!!checkedItems[doc.dataKey]}
                    onChange={handleChange}
                  />
                  <label className="form-check-label" htmlFor={doc?.dataKey}>
                    {documentHeaderLabel(doc, documentsList)}
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            downloadDocumentsAsZip(selectedDocs);
          }}
        >
          Download Zip
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default DownloadZipDoc;
